import { render, staticRenderFns } from "./addDialogJc.vue?vue&type=template&id=6469b6c4&scoped=true&"
import script from "./addDialogJc.vue?vue&type=script&lang=js&"
export * from "./addDialogJc.vue?vue&type=script&lang=js&"
import style0 from "./addDialogJc.vue?vue&type=style&index=0&id=6469b6c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6469b6c4",
  null
  
)

export default component.exports